import API from "./API"

const resource = "/dataset-types/"

const get = () => API.get(`${resource}`)

export default { get }
